import React from 'react';
import Tag from 'core/tag';

// type Props = {
//   onDeleteHandler: ?(*) => void,
//   pills: *[],
//   text: ?string,
// };
export default class Pills extends React.Component {
  render() {
    const { onDeleteHandler, text, pills } = this.props;
    const pillDisplay = pills
      ? pills.map((pill, i) => (
          <Tag
            key={i}
            onDelete={pill.onDelete || onDeleteHandler}
            text={pill.text}
            value={pill.value}
            className="truncated"
          />
        ))
      : '';
    return (
      <div>
        {text && <p>{text}</p>}
        {pillDisplay}
      </div>
    );
  }
}
